import { FileText, Bot, CreditCard, Eye, ChevronRight } from "lucide-react";

export function PopularArticles() {
  const articles = [
    {
      icon: FileText,
      iconBg: "bg-blue-100",
      iconBgHover: "group-hover:bg-blue-600",
      iconColor: "text-blue-600",
      iconColorHover: "group-hover:text-white",
      title: "How to connect WhatsApp Business API",
      description:
        "Step-by-step guide to set up your WhatsApp Business account and connect it to Kustomer Suite in under 5 minutes.",
      views: "2,340",
      readTime: "5 min read",
      updated: "Updated 2 days ago",
    },
    {
      icon: Bot,
      iconBg: "bg-pink-100",
      iconBgHover: "group-hover:bg-pink-600",
      iconColor: "text-pink-600",
      iconColorHover: "group-hover:text-white",
      title: "Configuring your AI chatbot personality",
      description:
        "Customize your AI assistant's tone, response style, and behavior to match your brand voice.",
      views: "1,890",
      readTime: "7 min read",
      updated: "Updated 1 week ago",
    },
    {
      icon: CreditCard,
      iconBg: "bg-green-100",
      iconBgHover: "group-hover:bg-green-600",
      iconColor: "text-green-600",
      iconColorHover: "group-hover:text-white",
      title: "Understanding Kustomer Suite pricing",
      description:
        "Learn about Startup, Business, and Corporate plans, including what's included and how billing works.",
      views: "1,567",
      readTime: "4 min read",
      updated: "Updated 3 days ago",
    },
  ];

  return (
    <div className="flex-1">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Popular Articles</h2>
          <p className="text-sm text-gray-500 mt-1">Most viewed help articles this week</p>
        </div>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors">
          View All →
        </button>
      </div>

      {/* Articles List */}
      <div className="space-y-4">
        {articles.map((article, index) => {
          const Icon = article.icon;
          return (
            <button
              key={index}
              className="
                group
                w-full
                bg-white
                border border-gray-200
                rounded-lg
                p-6
                text-left
                hover:shadow-md
                hover:border-blue-400
                transition-all
              "
            >
              <div className="flex items-start gap-4">
                {/* Icon */}
                <div
                  className={`
                    w-12 h-12 rounded-lg ${article.iconBg} ${article.iconBgHover}
                    flex items-center justify-center flex-shrink-0 transition-colors
                  `}
                >
                  <Icon className={`w-6 h-6 ${article.iconColor} ${article.iconColorHover} transition-colors`} />
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">{article.description}</p>
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1">
                      <Eye className="w-3.5 h-3.5" />
                      {article.views} views
                    </span>
                    <span>•</span>
                    <span>{article.readTime}</span>
                    <span>•</span>
                    <span>{article.updated}</span>
                  </div>
                </div>

                {/* Arrow */}
                <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 flex-shrink-0 transition-colors" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
